var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "88px",
    viewBox: "0 0 88 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Chevron-left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Chevron-left",
    stroke: "none",
    strokeWidth: 1,
    fill: "white",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M44,0 C68.300529,0 88,19.699471 88,44 C88,68.300529 68.300529,88 44,88 C19.699471,88 0,68.300529 0,44 C0,19.699471 19.699471,0 44,0 Z M44,6 C23.0131795,6 6,23.0131795 6,44 C6,64.9868205 23.0131795,82 44,82 C64.9868205,82 82,64.9868205 82,44 C81.9678074,23.0265286 64.9734714,6.03219265 44,6 Z M21.5981371,33 L44.5,55.8271897 L67.4018629,33 L71,36.5864051 L44.5,63 L18,36.5864051 L21.5981371,33 Z",
    id: "Shape",
    fillRule: "nonzero",
    transform: "translate(44.000000, 44.000000) rotate(90.000000) translate(-44.000000, -44.000000) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.ec6db1e173c8b6158072ee1f623b1d57.svg";
export { ForwardRef as ReactComponent };